import {SET_WECHAT_TOKEN} from '../action-types'

const initState={}
export default function auth(state=initState,action){
    const {type,data} = action
    switch(type){
        case SET_WECHAT_TOKEN:
            break;
    }

    return state

}